import { useCallback } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { SubProduct } from '@atlassian/jira-common-constants/src/sub-product-types.tsx';
import type { Collaborators } from '../get-collaborators/types.tsx';

export const usePostThirdPartyNudge = () => {
	return useCallback(
		async (
			featureVisitedCount: number,
			subProduct: SubProduct | null,
			collaboratorsWithConfluenceAccess: Collaborators,
			accessCapability: 'DIRECT_ACCESS' | 'REQUEST_ACCESS',
		) => {
			try {
				const options = {
					body: JSON.stringify({
						featureVisitedCount,
						subProduct,
						collaborators: collaboratorsWithConfluenceAccess.map((c) => c.id),
						accessCapability,
					}),
				};
				return performPostRequest(
					'/gateway/api/pi-gateway/webhooks/frontend/jira/cross-join-third-party-nudge',
					options,
				);
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				fireErrorAnalytics({
					meta: {
						id: 'usePostThirdPartyNudge',
						packageName: 'jiraCrossJoinThirdPartyNudges',
					},
					error,
					sendToPrivacyUnsafeSplunk: true,
				});
				throw new Error('Post third party nudge error');
			}
		},
		[],
	);
};
